module.exports = __webpack_public_path__ + "img/upload-id.f526010b.jpg";